// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_1yv","cls2":"SingularMentionCitationModal-cls2_3AA SingularMentionCitationModal-cls1_1yv"};